<div class="agpr-viAnswerPanel-result">
    <agpr-vi-engine-selector
        [id]="id"
        [engines]="engines"
        [selectedType]="selectedType"
        (selectedTypeChange)="select($event)"
    >
        @if (selectedEngine && !selectedEngine.loading) {
            <div class="agpr-viAnswerPanel-result-content">
                <h3 class="agpr-viAnswerPanel-result-content-header">
                    <img
                        class="agpr-viAnswerPanel-result-content-headerImage"
                        [src]="appBaseHref + selectedEngine.logoUrl"
                        alt=""
                        aria-hidden="true"
                    />
                    <span class="agpr-viAnswerPanel-result-content-headerText">{{ selectedEngine.label | localize }}</span>
                </h3>

                <agpr-tabs
                    #answerContent
                    class="agpr-viAnswerPanel-result-content-tabs"
                    (tabChange)="onTabChanged($event)"
                >
                    <agpr-tab
                        [id]="id + '_answerTab'"
                        heading="Common.dialog.aeoScout.answer"
                    >
                        @if (selectedEngine?.answerText) {
                            <div class="agpr-viAnswerPanel-result-content-answerTab">
                                <markdown class="agpr-viAnswerPanel-result-content-answerText"
                                    [data]="selectedEngine.answerText">
                                </markdown>
                            </div>
                        } @else {
                            <div class="agpr-viAnswerPanel-result-content-emptyTab">
                                <agpr-message [severity]="messageSeverityEnum.noContent">
                                    {{ "Common.dialog.aeoScout.noAnswer" | localize }}
                                </agpr-message>
                            </div>
                        }
                    </agpr-tab>

                    <agpr-tab
                        [id]="id + '_sourcesTab'"
                        heading="Common.dialog.aeoScout.sources"
                    >
                        @if (selectedEngine?.sources?.length == 0) {
                            <div class="agpr-viAnswerPanel-result-content-emptyTab">
                                <agpr-message [severity]="messageSeverityEnum.noContent">
                                    {{ "Common.dialog.aeoScout.noSources" | localize }}
                                </agpr-message>
                            </div>
                        } @else {
                            <ul class="agpr-viAnswerPanel-sourceCard-list" agprListKeyboardNavigation>
                                @for (source of selectedEngine.sources; track (selectedEngine.type + source.link + $index)) {
                                    <li class="agpr-viAnswerPanel-sourceCard-listItem">
                                        <ng-container *ngTemplateOutlet="sourceCard; context: { source: source }"></ng-container>
                                    </li>
                                }
                            </ul>
                        }
                    </agpr-tab>
                </agpr-tabs>

                @if (this.selectedTabId === this.answerTabId && this.selectedEngine?.answerText) {
                    <div class="agpr-viAnswerPanel-result-content-buttons">
                        <agpr-button
                            [id]="id + '_copyAnswerButton'"
                            class="agpr-viAnswerPanel-result-content-copy"
                            [style]="buttonType.tertiary"
                            label="Vi.copyAnswer"
                            (click)="copyAnswer($event, selectedEngine.answerText)"
                        ></agpr-button>
                    </div>
                }
            </div>
        } @else {
            <div></div>
        }
    </agpr-vi-engine-selector>
</div>

<ng-template #sourceCard let-source="source">
    <div class="agpr-viAnswerPanel-sourceCard">
        @if (source?.outlet?.isAiReference) {
            <div class="agpr-viAnswerPanel-label">
                <span
                    role="img"
                    class="fa-kit-duotone fa-agpr-ai-badge"
                    agprTooltip="Discover.badges.tooltips.outlet.aiReferenceLeader"
                ></span>
            </div>
        }

        <div class="agpr-contextMenu bottom right">
            @if (source.link) {
                <agpr-button
                    [style]="buttonType.contextMenu"
                    icon="fa-kit-duotone fa-agpr-copy"
                    tooltip="Reports.sharedReports.rhp.copyUrl"
                    tooltipPosition="top"
                    (click)="copyOutletUrl(source.link)"
                ></agpr-button>
            }
            @if (source.outletId && hasTargetingPermission) {
                <agpr-button
                    [style]="buttonType.contextMenu"
                    icon="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"
                    tooltip="Discover.entityProfile.expand"
                    tooltipPosition="top"
                    (click)="expandOutletProfile(source.outletId)"
                ></agpr-button>
                <agpr-button
                    class="contextMenu-button"
                    [style]="buttonType.contextMenu"
                    [icon]="'fa-regular fa-duotone fa-user-plus'"
                    tooltip="Discover.targeting.actions.manageLists"
                    tooltipPosition="top"
                    (click)="openManageListDialog(source.outlet)"
                ></agpr-button>
            }
        </div>
        @if (source.outlet && !source.imageLoadError) {
            <img
                class="agpr-viAnswerPanel-sourceCard-outletIcon"
                [src]="source.outlet.avatarUrl"
                alt=""
                (error)="source.imageLoadError = true"
            />
        } @else {
            <span class="agpr-viAnswerPanel-sourceCard-outletIconDefault fa-solid fa-globe"></span>
        }
        <div class="agpr-viAnswerPanel-sourceCard-center">
            @if (source.outletId && hasTargetingPermission) {
                <agpr-button
                    [id]="id + '_expandOutletProfile'"
                    class="agpr-viAnswerPanel-sourceCard-outletNameButton agpr-viAnswerPanel-label-title"
                    [style]="buttonType.link"
                    [label]="source.outlet.name"
                    tooltip="Discover.universal.outletLink.tooltip"
                    tooltipPosition="top"
                    (click)="expandOutletProfile(source.outletId)"
                >
                    <span
                        role="img"
                        class="agpr-viAnswerPanel-sourceCard-outletProfileIcon fa-kit fa-agpr-outlet-solid"
                        [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                    ></span>
                </agpr-button>
            } @else {
                <span class="agpr-viAnswerPanel-sourceCard-outletNameText agpr-viAnswerPanel-label-title">
                    {{ source.outlet?.name || '' }}
                </span>
            }
            <a
                class="agpr-viAnswerPanel-sourceCard-link"
                [href]="source.link"
                target="_blank"
            >
                {{ source.link }}
            </a>
            <span class="agpr-viAnswerPanel-sourceCard-contactName">{{ source.contactName }}</span>
        </div>
    </div>
</ng-template>
